import React from 'react';
import {Input, Select, Form, Modal, InputNumber} from 'antd';
import moment from 'moment';



const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}

const formLargeItemLayout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 19,
  },
}

const modalMaster = ({visible,type,item = {},onOk,onCancel,form: {getFieldDecorator,validateFields,getFieldsValue,
	},}) => {


	function handleOk() {
		validateFields((err, values) => {
			if (err) {
				return;
			}

			if (Object.getOwnPropertyNames(values).length === 0) {
				onCancel();
				return;
			}

			// 根据 guarantee_type 的值判断是服务费模式还是加价模式
			let guaranteeTypeValue = values.guarantee_type === '企信宝' ? 0 : 1;

			let newValue = {
				...item,
				deposit_quota: values.deposit_quota * 100,
				guarantee_type: guaranteeTypeValue,
			};

			onOk(newValue);
		});
	}


	//sap_no位数检查
	const validQuota = (rule, value, callback) => {
		if (value <1) {
			callback('必须大于0元');
		} else {
			callback();
		}
	};

	const modalOpts = {
	  title: `${type === 'create' ? '新建' : '推荐'}`,
	  visible,
	  onOk: handleOk,
	  onCancel,keyboard:false,maskClosable:false,
	  wrapClassName: 'vertical-center-modal',
	  width: 520,
	  //okText: '确认',
      //cancelText: '取消',
	}



	return (
	  <Modal {...modalOpts}>
		  <Form layout="horizontal">
			  <Form.Item label={'客户'} {...formItemLayout}>
				  {getFieldDecorator('enterprise_name', {
					  initialValue: item.enterprise_name,
					  rules: [{ required: true, message: '客户的公司名称' }],
				  })(
					  <Input disabled={type !== 'create'} />
				  )}
			  </Form.Item>
			  <Form.Item label={'产品模式'} {...formItemLayout}>
				  {getFieldDecorator('guarantee_type', {
					  initialValue: '企信宝',  // 初始值为字符串 '服务费模式'
					  rules: [{ required: true, message: '产品模式必填' }],
				  })(
					  <Input disabled style={{ color: 'blue', border: 'none', boxShadow: 'none' }} />
				  )}
			  </Form.Item>





			  <Form.Item label={'担保金额(元)'} {...formItemLayout}>
				  {getFieldDecorator('deposit_quota', {
					  initialValue: type === 'update' ? item.apply_quota / 100 : null,
					  rules: [
						  { required: true, message: '担保金额必填' },
						  { validator: validQuota },
					  ],
				  })(
					  <InputNumber
						  style={{ width: '100%' }}
						  precision={2}
					  />
				  )}
			  </Form.Item>
		  </Form>

	  </Modal>
	)
}


const ModalRecommendRender = Form.create()(modalMaster);


export default ModalRecommendRender;
